import { render, staticRenderFns } from "./FiscalDocument.vue?vue&type=template&id=b3268552"
import script from "./FiscalDocument.vue?vue&type=script&lang=js"
export * from "./FiscalDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports